module.exports = __webpack_public_path__ + "static/media/draw-circle.76536b68.svg";